import { Box } from '@mui/material';
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import ExportDatasetModal from '~/containers/viewer/explorer-sidebar/Export/ExportDatasetModal';
import Viewport from '~/containers/viewer/viewport';
import ConnectorWorkflows from '~/containers/workflows/ConnectorWorkflows';
import { useConnectorJobOrchestrator } from '~/hooks/workflows/connector/useConnectorJobOrchestrator';

export default function Session() {
    useConnectorJobOrchestrator();
    const { sessionId } = useParams();
    if (!sessionId) {
        return <p>Missing session information.</p>;
    }

    return (
        <Fragment>
            <Box position="relative">
                <Viewport />
                <ConnectorWorkflows sessionId={sessionId} />
            </Box>
            <ExportDatasetModal />
        </Fragment>
    );
}
